export function scoreAuditDate(value) {
  if (value === null || value === undefined || value === "") return null;
  // iOS encodes these dates as seconds since 2001, not Unix seconds.
  const date = new Date(typeof value === "number" ? (value + 978307200) * 1000 : value);
  return Number.isNaN(date.getTime()) ? null : date;
}
